export default {"src":"/_next/static/media/firepit.67d85a1b.svg","height":45,"width":42,"blurWidth":0,"blurHeight":0};